'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 'left';
var RIGHT = exports.RIGHT = 'right';
var BOTTOM = exports.BOTTOM = 'bottom';
var TOP = exports.TOP = 'top';
var TEXT_ABOVE = exports.TEXT_ABOVE = 'ideographic';
var TEXT_BELOW = exports.TEXT_BELOW = 'hanging';
var TEXT_MIDDLE = exports.TEXT_MIDDLE = 'middle';
var TEXT_START = exports.TEXT_START = 'start';
var TEXT_END = exports.TEXT_END = 'end';
var ALWAYS = exports.ALWAYS = 'always';
var NEVER = exports.NEVER = 'never';
var HIGHLIGHT = exports.HIGHLIGHT = 'highlight';
var BASELINE = exports.BASELINE = 'baseline';
var FOCUS = exports.FOCUS = 'focus';
var OVER = exports.OVER = 'over';
var DISPLAYED = exports.DISPLAYED = 'inherit';
var BLOCK_DISPLAYED = exports.BLOCK_DISPLAYED = 'block';
var NOT_DISPLAYED = exports.NOT_DISPLAYED = 'none';
var VISIBLE = exports.VISIBLE = 'visible';
var HIDDEN = exports.HIDDEN = 'hidden';
var TOOLTIP_CURSOR_X_OFFSET = exports.TOOLTIP_CURSOR_X_OFFSET = 16;
var TOOLTIP_CURSOR_Y_OFFSET = exports.TOOLTIP_CURSOR_Y_OFFSET = 0;
var DEFAULT_TICK_VALUES_COUNT = exports.DEFAULT_TICK_VALUES_COUNT = 10;
var MAX_TICK_VALUES = exports.MAX_TICK_VALUES = 50;
var DEFAULT_HIGHLIGHT_INDEX = exports.DEFAULT_HIGHLIGHT_INDEX = -1;
var DEFAULT_BASELINE_INDEX = exports.DEFAULT_BASELINE_INDEX = -1;
var ANNOTATION_SERIE_OFFSET = exports.ANNOTATION_SERIE_OFFSET = 8;
var NONE = exports.NONE = 'none';
var LINEAR = exports.LINEAR = 'linear';
var ORDINAL = exports.ORDINAL = 'ordinal';
var TIME = exports.TIME = 'time';
var ROTATED = exports.ROTATED = 'rotated';
var UNROTATED = exports.UNROTATED = 'unrotated';
var DEFAULT_PROJECTION = exports.DEFAULT_PROJECTION = 'geoMercator';